import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-030",
  "use": "icon-030-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-030\">\r\n  <path d=\"M14 4.50458L12.6667 5.83791V2.66634H6.66667V5.99967H3.33333V13.333H12.6667V11.4947L14 10.1614V14.0051C14 14.3703 13.7034 14.6663 13.3377 14.6663H2.66227C2.29651 14.6663 2 14.3664 2 13.9951V5.33301L6.00213 1.33301H13.3319C13.7009 1.33301 14 1.63655 14 1.99421V4.50458ZM14.5188 5.87141L15.4616 6.81421L10.2761 11.9997L9.33193 11.9983L9.33333 11.0569L14.5188 5.87141Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol